import { ResponsiveCarousel } from '@base/components/src/Carousel';
import clsx from 'clsx';
import config from 'config-base';
import styles from './Addon.module.css';
import { AddonProps } from './types';

const Addon = <V extends Record<string, unknown> = Record<string, unknown>>({
  id,
  title,
  data,
  renderAddonItem,
}: AddonProps<V>) => (
  <div id={id} className={clsx(styles.addonItem, { [styles.addonItemAGD]: config.brandCode !== '0' })}>
    {title && <p className={clsx(styles.addonTitle, { [styles.addonTitleAGD]: config.brandCode !== '0' })}>{title}</p>}
    <ResponsiveCarousel<V>
      buttonsAbsolute
      hideDotButtons
      visibleSlidesQuery={{ xxl: 4, xl: 4, lg: 3, md: 3, sm: 2, xs: config.brandCode === '2' ? 2 : 1 }}
      slideData={data}
      carouselPadding={'h-[330px] !pb-0'}
      carouselHeight={'h-[330px]'}
      renderSlide={renderAddonItem}
    />
  </div>
);

export default Addon;
